import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Pages from "./Components/Pages";
import IntegracaoMeta from "./Components/Pages/IntegracaoMeta";
import TesteBusca from "./Components/Pages/TesteBusca";
import Navbar2 from "./Components/Navbar2";
import FileImport from "./Components/Pages/FileImport";
import ComoConhecerMeuCliente from "./Components/Pages/ComoConhecerMeuCliente";
import SegmentacaoClientes from "./Components/Pages/SegmentacaoClientes";
import HowPublicoPotencial from "./Components/Pages/HowPublicoPotencial";
import ErrorPublicoPersonalizado from "./Components/Pages/ErrorPublicoPersonalizado";
import ErrorContaAnuncio from "./Components/Pages/ErrosContaAnuncio";
import DataAnalytics from "./Components/Pages/DataAnalytics";
import Integracoes from "./Components/Pages/Integracoes";
import HowImport from "./Components/Pages/HowImport";
import WhatPublicoPotencial from "./Components/Pages/WhatPublicoPotencial";
import WhyPublicoPotencial from "./Components/Pages/WhyPublicoPotencial";
import HowSegmentacaoClientes from "./Components/Pages/HowSegmentacaoClientes";
import InfoPsicografico from "./Components/Pages/InfoPsicografico";
import VariaveisSalesbox from "./Components/Pages/VariaveisSalesbox";
import VariaveisDemograficas from "./Components/Pages/VariaveisDemograficas";
import VariaveisPsicograficas from "./Components/Pages/VariaveisPsicograficas";
import VariaveisFinanceiras from "./Components/Pages/VariaveisFinanceiras";
import EnetendoRfv from "./Components/Pages/EntendendoRfv";
import DataIntelligence from "./Components/Pages/DataIntelligence";
import SmartSegmentation from "./Components/Pages/SmartSegmentation";
import GeoMarketing from "./Components/Pages/GeoMarketing";
import PersonasPsicograficas from "./Components/Pages/PersonasPsicograficas";
import PrimeiroAcesso from "./Components/Pages/PrimeiroAcesso";
import MinhaConta from "./Components/Pages/MinhaConta";
import Login from "./Components/Pages/Login";
import RedefinirSenha from "./Components/Pages/RedefinirSenha";
import AnaliseGeografica from "./Components/Pages/AnaliseGeografica";
import ImagePage from "./Components/Pages/ImagePage";
import JornadaCliente from "./Components/Pages/JornadaCliente";
import AnaliseDescritiva from "./Components/Pages/AnaliseDescritiva";
import ErroEnriquecimento from "./Components/Pages/ErroEnriquecimento";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/pages",
    element: <Pages />,
  },
  {
    path: "/como-conectar-minha-conta-do-facebook-ou-instagram",
    element: <IntegracaoMeta />,
  },
  {
    path: "/testebusca",
    element: <TesteBusca />,
  },
  {
    path: "/navbar2",
    element: <Navbar2 />,
  },
  {
    path: "/search-results",
    element: <TesteBusca />,
  },
  {
    path: "/o-que-e-enriquecimento-de-dados",
    element: <FileImport />,
  },
  {
    path: "/como-conhecer-meu-cliente",
    element: <ComoConhecerMeuCliente />,
  },
  {
    path: "/o-que-e-a-segmentacao-de-clientes",
    element: <SegmentacaoClientes />,
  },
  {
    path: "/como-criar-uma-segmentacao-de-clientes",
    element: <HowSegmentacaoClientes />,
  },
  {
    path: "/como-criar-um-publico-potencial",
    element: <HowPublicoPotencial />,
  },

  {
    path: "/por-que-escolher-uma-regiao-geografica",
    element: <WhyPublicoPotencial />,
  },

  {
    path: "/o-que-e-um-publico-potencial",
    element: <WhatPublicoPotencial />,
  },
  {
    path: "/solucao-de-problemas-publicos-personalizados-do-facebook",
    element: <ErrorPublicoPersonalizado />,
  },
  {
    path: "/solucao-de-problemas-conta-de-anuncio",
    element: <ErrorContaAnuncio />,
  },

  {
    path: "/data-analytics",
    element: <DataAnalytics />,
  },
  {
    path: "/integracoes",
    element: <Integracoes />,
  },

  {
    path: "/como-enriquecer-meus-dados",
    element: <HowImport />,
  },

  {
    path: "/como-acessar-a-analise-descritiva-da-minha-base",
    element: <AnaliseDescritiva />,
  },

  {
    path: "/o-que-sao-as-informacoes-psicograficas-da-sales-box",
    element: <InfoPsicografico />,
  },

  {
    path: "/variaveis-salesbox",
    element: <VariaveisSalesbox />,
  },

  {
    path: "/variaveis-demograficas",
    element: <VariaveisDemograficas />,
  },

  {
    path: "/variaveis-psicograficas",
    element: <VariaveisPsicograficas />,
  },

  {
    path: "/variaveis-financeiras",
    element: <VariaveisFinanceiras />,
  },

  {
    path: "/entendendo-o-rfv-recencia-frequencia-e-valor",
    element: <EnetendoRfv />,
  },

  {
    path: "/data-intelligence",
    element: <DataIntelligence />,
  },

  {
    path: "/smart-segmentation",
    element: <SmartSegmentation />,
  },

  {
    path: "/geomarketing",
    element: <GeoMarketing />,
  },

  {
    path: "/personas-psicograficas",
    element: <PersonasPsicograficas />,
  },

  {
    path: "/como-realizar-meu-primeiro-acesso",
    element: <PrimeiroAcesso />,
  },

  {
    path: "/minha-conta-e-login",
    element: <MinhaConta />,
  },

  {
    path: "/como-fazer-login",
    element: <Login />,
  },

  {
    path: "/esqueci-minha-senha-o-que-fazer",
    element: <RedefinirSenha />,
  },

  {
    path: "/analise-geografica",
    element: <AnaliseGeografica />,
  },

  {
    path: "/imagepage",
    element: <ImagePage />,
  },

  {
    path: "/jornada-do-cliente",
    element: <JornadaCliente />,
  },

  {
    path: "/solucao-de-problemas-enriquecimento-com-erro-ou-pendencias",
    element: <ErroEnriquecimento />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
